// src/hooks/countries/useGetCountry.js
import { useQuery } from "@tanstack/react-query";
import { getCountry } from "../../api/apiCountries";

const QUERY_KEY = ["country"];

const useGetCountry = (id) => {
    const {
        data,
        isLoading,
        isError,
        error,
    } = useQuery({
        queryKey: [...QUERY_KEY, id],
        queryFn: () => getCountry(id),
        enabled: !!id,
    });

    return {
        isLoading,
        error: isError ? error : null,
        country: data?.data || data || null,
    };
};

export default useGetCountry;
